import { Controller } from "@hotwired/stimulus";
import WebViewEventService from "../../../services/WebViewEventService";

export default class extends Controller {
  connect() {
    try {
      rdt("track", "Lead");
      rdt("track", "Custom", { customEventName: "purchase" });
    } catch (err) {
      console.warn("Reddit pixel not initialized yet");
    }
  }

  myQrCodesBtn(e) {
    const urlParams = new URLSearchParams(window.location.search);
    const isNavigationDisabled = urlParams.get("disable_navigation") === "1";

    if (isNavigationDisabled) {
      WebViewEventService.linkToMyQrCodes();
    } else {
      window.location.href = e.target.dataset.href;
    }
  }
}
